import React, { useEffect, useState, useMemo } from 'react'; // Added useMemo
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import './KatalogAlatGelas.css'; // Import the CSS file

const KatalogAlatGelas = () => {
  const [alatGelasList, setAlatGelasList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [selectedImage, setSelectedImage] = useState(null); // State for image popup
  const navigate = useNavigate(); // Hook for navigation

  // Fetch glassware
  const fetchAlatGelas = async () => {
    setLoading(true);
    setError('');
    try {
      const alatGelasRef = collection(db, 'alat_gelas');
      const q = query(alatGelasRef, orderBy('nama')); // Order by name
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));
      setAlatGelasList(data);
    } catch (err) {
      console.error("Error fetching glassware:", err);
      setError('Gagal memuat data alat gelas.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlatGelas();
  }, []);

  // Filtered list based on search term
  const filteredAlatGelasList = useMemo(() => {
    if (!searchTerm) {
      return alatGelasList;
    }
    return alatGelasList.filter(alat =>
      alat.nama.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (alat.kode && alat.kode.toLowerCase().includes(searchTerm.toLowerCase()))
    );
  }, [alatGelasList, searchTerm]);

  // Handlers for navigation buttons
  const handleAjukanPeminjaman = (alat) => {
    // Use the new nested path under /dashboard
    navigate('/dashboard/form-peminjaman-alat', {
      state: { alatId: alat.id, namaAlat: alat.nama, type: 'alat_gelas' } // Pass type
    });
  };

  // Handler for image click
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
  };

  // Handler to close image popup
  const handleCloseImage = () => {
    setSelectedImage(null);
  };


  return (
    <div className="katalog-alatgelas-container">
      <h2>Katalog Alat Gelas</h2>

      {error && <div className="error-message">{error}</div>}

      {/* Search Input */}
      <div className="search-container" style={{ marginBottom: '20px', maxWidth: '400px' }}>
        <input
          type="text"
          placeholder="Cari alat gelas berdasarkan nama atau kode..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
          style={{ width: '100%', padding: '8px 10px', borderRadius: '4px', border: '1px solid #ccc' }}
        />
      </div>


      {loading ? (
        <div className="loading-message">Memuat data alat gelas...</div>
      ) : (
        <div className="katalog-alatgelas-table-container">
          <table className="katalog-alatgelas-table">
            <thead>
              <tr>
                <th>Nama Alat Gelas</th>
                <th>Kode</th>
                <th>Spesifikasi</th>
                <th>Lokasi</th>
                <th>Gambar</th>
                <th>SOP</th>
                <th>Aksi</th> {/* Added Actions Column */}
              </tr>
            </thead>
            <tbody>
              {filteredAlatGelasList.map((alat) => (
                <tr key={alat.id}>
                  <td>{alat.nama || 'N/A'}</td>
                  <td>{alat.kode || 'N/A'}</td>
                  <td>{alat.spesifikasi || 'N/A'}</td>
                  <td>{alat.lokasi || 'N/A'}</td>
                  <td>
                    {/* Using gambarUrl as per original file */}
                    {alat.gambarUrl ? (
                      <img 
                        src={alat.gambarUrl} 
                        alt={alat.nama} 
                        className="table-image" 
                        onClick={() => handleImageClick(alat.gambarUrl)}
                        style={{ cursor: 'pointer' }}
                      />
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td>
                    {/* Using sopUrl as per original file */}
                    {alat.sopUrl ? (
                      <a href={alat.sopUrl} target="_blank" rel="noopener noreferrer" className="table-link">
                        Lihat SOP
                      </a>
                    ) : (
                      'N/A'
                    )}
                  </td>
                   {/* Action Button */}
                   <td className="action-buttons" style={{ whiteSpace: 'nowrap' }}>
                     <button
                       onClick={() => handleAjukanPeminjaman(alat)}
                       className="btn btn-pinjam"
                       style={{ padding: '5px 10px', fontSize: '12px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                     >
                       Pinjam
                     </button>
                  </td>
                </tr>
              ))}{/* Remove potential whitespace here */}
              {filteredAlatGelasList.length === 0 && !loading && (
                <tr>
                  <td colSpan="7" style={{ textAlign: 'center' }}> {/* Updated colspan */}
                     {searchTerm ? 'Tidak ada alat gelas yang cocok dengan pencarian.' : 'Tidak ada data alat gelas yang tersedia.'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Image Popup Modal */}
      {selectedImage && (
        <div 
          className="image-popup-overlay" 
          onClick={handleCloseImage}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
        >
          <div 
            className="image-popup-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'relative',
              maxWidth: '90%',
              maxHeight: '90%',
              backgroundColor: 'white',
              padding: '10px',
              borderRadius: '5px'
            }}
          >
            <button 
              onClick={handleCloseImage}
              style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                background: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '30px',
                height: '30px',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
            >
              &times;
            </button>
            <img 
              src={selectedImage} 
              alt="Enlarged view" 
              style={{
                maxWidth: '100%',
                maxHeight: '80vh',
                display: 'block'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default KatalogAlatGelas;
